<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> لیست کلاس های فعال </template>
    <CustomTable
      ref="observeTable"
      :pageNumber="1"
      :count="10"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="mastersList"
      @changePage="() => {}"
    >
      <template #actions="data">
        <BButton
          variant="success"
          size="sm"
          @click="renderRowDetails(data.index)"
        >
          مشاهده جزئیات
        </BButton>
      </template>
      <template #cellDetails="data">
        <ObserveListDetailsSection
          :scheduleDetails="data.item"
        ></ObserveListDetailsSection>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getObserveList();
  },
  data() {
    return {
      isLoading: false,
      mastersList: null,
      tableColumns: [
        {
          key: "masterId",
          label: "شناسه استاد",
        },
        {
          key: "masterFullName",
          label: "نام استاد",
        },
        {
          key: "hasActiveClass",
          label: "کلاس فعال دارد",
          formatter: (val) => (val ? "بله" : "خیر"),
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderRowDetails(rowIndex) {
      if (this.$refs.observeTable) {
        this.$refs.observeTable.showRowDetails(rowIndex);
      }
    },
    async getObserveList() {
      try {
        this.isLoading = true;
        let _this = this;
        let observeTodayMasters = new ObserveTodayMasters(_this);
        await observeTodayMasters.fetch((response) => {
          if (response.isSuccess) {
            _this.mastersList = response.data.filter(
              (item) => item.schedules.length
            );
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    BButton,
    ObserveListDetailsSection,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import ObserveListDetailsSection from "@/views/components/Observe/ObserveListDetailsSection.vue";
import { ObserveTodayMasters } from "@/libs/Api/Master";
import { BButton } from "bootstrap-vue";
</script>
